export const PaymentErrorPagePath = '/payment-error';
export const SubscriptionErrorPagePath = '/subscription-error';
export const InstalmentPlanErrorPath = '/instalment-plan-error';
export const GenericErrorPath = '/error';
